import { gql } from '@apollo/client'
import { countryFragment } from '~/graphql/fragments/country'

export const cityResultFragment = gql`
  fragment cityResult on CityResult {
    id
    slug
    name
    geoInfo {
      latitude
      longitude
    }
    country {
      ...country
    }
  }

  ${countryFragment}
`
